import { Component, OnInit, ViewChildren, QueryList } from '@angular/core';
import { FormArray, FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Formatter } from '../common/services/formatter';
import { FormValidator } from '../common/services/formValidator.service';
import { PopupComponent } from '../common/utilities/popup/popup.component';
import { RouteHandlerService } from '../common/services/routeHandler.service';
import { PincodeHandlerService } from '../common/services/pincodeHandler.service';
import { CommonConstants } from '../common/utilities/commonConstants';
import { HomeComponent } from '../home/home.component';
import { CookieHandlerService } from '../common/services/cookieHandler.service';
import { RouteContextProvider } from '../common/services/routeContextProvider.service';
import { SessionHandlerService } from '../common/services/sessionHandler.service';
import { SharedService } from 'src/app/common/services/sharedService';
import { AnalyticsService } from '../common/services/device.analytics.service';
import { GetGoingCall } from './getGoingNow.service';
import { DrawerComponent } from '../common/utilities/drawer/drawer.component';
import { MoreAboutYouCall } from '../questionnaireModule/moreAboutYou/moreAboutYou.service';
import { WhatsappConsentService } from 'src/app/common/services/consent.service';
import { GoogleAnalyticsService } from '../common/services/google_analytics.service';
import { AppSummaryContent } from '../detailsModule/personalDetails/content';
import { ActivatedRoute, Router } from '@angular/router';
import { PlanDetailsService } from '../common/services/planDetails.service';
import { adobe_analytics_service } from '../common/services/adobe_analytics_service';
import { HomeService } from '../home/home.service';
import { ConfigResolve } from '../common/services/config.resolve.service';
import { delay } from 'rxjs/operators';
import { startWith, pairwise } from 'rxjs/operators';
import { SsoService } from '../shared/services/sso.service';
import { DialogService } from '../shared/components/dialog/dialog.service';
import { DialogRef } from '../shared/components/dialog/dialog-ref';
import { CommonErrorMessageDrawerComponent } from '../shared/components/dialog/common-error-message-drawer/common-error-message-drawer.component';
import { ClevertapEventHandlerService } from 'src/app/shared/services/cleverTapHandler.service';

const GENDER_LIST = ['Male', 'Female'];
let FAQs = [
    {
        q: 'Do I have to pay GST on health insurance premium?',
        a: 'Yes, a GST is charged on the health insurance premiums payable by you.',
        isOpen: false
    },
    {
        q: 'Does the premium amount vary from insurer to insurer?',
        a: 'Yes, every insurer charges a distinct health insurance premium.',
        isOpen: false
    },
    {
        q: 'What are deductibles?',
        a: 'Deductibles is an amount that is a part of the treatment cost that you are expected to pay by yourself, while the rest is paid by the insurer.',
        isOpen: false
    },
    {
        q: 'What is a co-payment clause?',
        a: 'In case of a co-payment clause, the medical treatment cost is split between you and the insurer by a certain percentage.',
        isOpen: false
    }
];



const INSURED_MEMBER_TYPES = [
    {
        id: '01',
        title: 'Self'
    },
    {
        id: '02',
        title: 'Spouse'
    },
];

const INSURED_OTHER_MEMBER_TYPES = [
    {
        id: '05',
        title: 'Father'
    },
    {
        id: '06',
        title: 'Mother'
    },

];

const SON = 'Son';
const DAUGHTER = 'Daughter';

@Component({
    templateUrl: './getGoingNow.template.html',
    styleUrls: ['./getGoingNow.style.scss'],
    providers: [HomeComponent, GetGoingCall, MoreAboutYouCall]
})
export class GetGoingComponent implements OnInit {
    public genderList = GENDER_LIST;
    public selectedGender: string;
    public cityName: any;
    public FAQS = FAQs;
    public DOB_DATE_RANGES: any;
    public gender_count: number = 0;
    @ViewChildren(PopupComponent) public PopupComponent: QueryList<any>;
    public ContentPopup;
    public Config = { show: false, backdrop: 'static' };
    public GetGoingFormGroup: FormGroup;
    public IsCorrectMobile: string = null;
    public IsValid = false;
    public showLoader = false;
    public validatePIN: boolean = false;
    public insuringFor: string;
    public dobEldest: string;
    public ServiceError: any;
    public errorMessage: string;
    public isOpen: boolean;
    public latestPinCode: any;
    public isServiceError: boolean;
    public curr_gender: string;
    public serviceMessage: string;
    public visitorID: any;
    public resultKey: any;
    public tabClick = 'overview';
    public AnswerConfirmationPopupData: { Title: string; Id: string; Config: CustomModalOptions; };
    public InsProductType: any;
    public ShowOnlyGroupPlan: boolean;
    public healthOtpForm: FormGroup;
    public showOtpDrawer = false;
    public s = "";
    @ViewChildren(DrawerComponent) public drawer: QueryList<DrawerComponent>;
    public IsOTPResend = false;
    public resendOtpExceedFlag = false;
    public mobileOtpTrails = 0;
    public wrongOtpMsg: string;
    public isTimerStarted = false;
    public resendOTPCount = 0;
    public IsServiceFailure = false;
    public mobileNumber;
    public ServiceOTPError: string;
    public whatsAppConsent = true;
    public today = new Date();
    public ShowConsent = false;
    public termsContent = AppSummaryContent.BAGIC;
    public dobforotp: string;
    public title: string;
    public desc: string;
    public bflJourney: any;
    public IsEdit = false;

    // insuring for
    public SonCount = 0;
    public DaughterCount = 0;
    public lastSonCount = 4 - this.DaughterCount;
    public lastDaughterCount = 4 - this.SonCount;
    public MembersAddedLable: string;
    public MembersAddedToList = [];
    public familyCheck = true;
    public SelectInsurerFormGroup: FormGroup;
    public InsuredMemberList = INSURED_MEMBER_TYPES;
    public InsuredOtherMemberList = INSURED_OTHER_MEMBER_TYPES;
    isMobileFlag: any;
    appQuoteCriteriaId;
    hasDobError = false;
    timerOn: boolean;
    timer;
    setTime;
    timerInsuringFor;
    otpFieldtimer;
    public InsuranceDetails: any;
    public EditResponse;
    InsurerdResponse: any;
    private insuredCount: any;
    public PhoneNumber: any;
    public showOnlyGroupPlan: any;
    public proposerDobResponse: string;
    public PincodeResponse: string;
    public isEditForgetGoingEdit = false;
    private formattedDOB: any;
    isOtpPasted: boolean;
    isLandingPage: boolean;
    backFlow: any;
    isMobileFieldDisable: boolean;
    ssoEnabled: boolean;
    insuringMemberList: any[];
    insuringMemberLable: string;
    SelectedSonCount: number = 0;
    SelectedDaughterCount: number = 0;
    public isHealthQuoteId: String = "";
    demogApiResponse: any;
    proposerName: string;

    constructor(
        private _formBuilder: FormBuilder,
        public FormValidators: FormValidator,
        private formatter: Formatter,
        private _pincodeService: PincodeHandlerService,
        private homeComponent: HomeComponent,
        private _cookieHandler: CookieHandlerService,
        private _routeContextProvider: RouteContextProvider,
        private _sessionHandlerService: SessionHandlerService,
        private _sharedService: SharedService,
        private _analyticsService: AnalyticsService,
        private _GetGoingCall: GetGoingCall,
        private routeHandlerService: RouteHandlerService,
        private _moreAboutYouCall: MoreAboutYouCall,
        private _whatsappConsentService: WhatsappConsentService,
        private _googleAnalyticsService: GoogleAnalyticsService,
        private _planDetailsService: PlanDetailsService,
        public _adobe_analytics_service: adobe_analytics_service,
        private _homeService: HomeService,
        private _currentRoute: ActivatedRoute,
        private analyticsService: AnalyticsService,
        private ssoService: SsoService,
        private router: Router,
        private dialog: DialogService,
        public drawerCompOpen: DialogRef,
        public _dialogService: DialogService,
        public _dialogRef: DialogRef,
        private _cleverTapService: ClevertapEventHandlerService
    ) {

    }
    public ngOnInit() {
        this.backFlow = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.backFlow);
        if(!this.backFlow){
            this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.processId, '');
        }else{
            this.getTaskDetails();
        }
        document.getElementById('seohidden').style.display = 'block';
        this.bflJourney = this._sharedService.isBFLJourney();
        this.ssoEnabled = (this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.ssoEnabled) === 'true') ? true : false;
        console.log("ssoEnabled-", this.ssoEnabled);
        this._currentRoute.url.forEach(url => {
            if (url.toString() == CommonConstants.Routes.Application.GetGoingNow) {
                this.isLandingPage = true;
                this.isHealthQuoteId = "Health_GetQuote";
            }
            if (url.toString() == CommonConstants.Routes.Application.GetGoingNowEdit) {
                this.getTaskDetails();
                this.isHealthQuoteId = "Health_GetQuoteEdit";

            }
        });
        console.log(this.bflJourney);
        this.startFieldTimer();
        this._sessionHandlerService.DeleteSession([CommonConstants.CookieKeys.selectedPlanType]);
        this._sessionHandlerService.DeleteSession([CommonConstants.CookieKeys.selectedAggregateDeductible]);
        // If user is coming through insurance mall and is already logged in there, prefill details
        this.isMobileFlag = this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.IsMobile) === '1'
        if (this.ssoEnabled === true) {
            //call DEMOG API
            this.prefillSSOUserData();
            this.removeQueryParams();
        } else if (this.ssoEnabled === false) {
            if(this.isMobileFlag){
                //call DEMOG API
                this.prefillSSOUserData();
            }
            this.removeQueryParams();
        }

        // this is added in case if initial home compo's auth calls are not done
        const mainContainerHeight = document.getElementById('main-app-container').style.minHeight = '89vh';

        if (!this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.SecretKey)) {
            this.homeComponent.initiateAuthentication();
        }
        this.buildFormGroup();
        this.buildHealthOtpForm();
        // Get Adobe author visitor id
        setTimeout(() => {
            this.visitorID = window['_satellite']['getVisitorId']()['getMarketingCloudVisitorID']();
        }, 5000);
        this.InsProductType = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.InsProductType);
    }

    removeQueryParams() {
        this.router.navigate(
            [],
            {
                queryParams: {
                    token: null,   // Remove token query param
                    key: null, // Remove key query param
                },
                queryParamsHandling: 'merge',
            }
        );
    }

    // Next Button Click
    public validateYear() {
        const dateError = this.ValidateProposerDOB({ ['year']: this.GetGoingFormGroup.controls['year'].value });
        if (dateError) {
            this.GetGoingFormGroup.controls['year'].setErrors(dateError);
        }

        // this.bothDOBHasError();
    }

    public validateYearEldest() {
        const dateError = this.ValidateDOB({ ['year']: this.SelectInsurerFormGroup.controls['year'].value });
        if (dateError) {
            this.SelectInsurerFormGroup.controls['year'].setErrors(dateError);
        }
        // this.bothDOBHasError();
    }

    setOTPValue(otpValue) {
        Array.from(otpValue).forEach((x, index) => {
            let counter = index + 1;
            this.healthOtpForm.controls['digit' + counter].setValue(x);
        });
    }

    onPaste(eventData, elem?: HTMLInputElement) {
        this.isOtpPasted = true;
        const clipboardData = eventData.clipboardData;
        const otpValue = clipboardData.getData('text');
        if (/\d{6}/.test(otpValue)) {
            this.setOTPValue(otpValue);
            if (elem) {
                // setTimeout(() => {
                elem.value = otpValue.substr(0, 1);
                this.healthOtpForm.controls['digit1'].setValue(elem.value);
                elem.setAttribute('maxlength', '1');
                // }, 10);
            }
        } else {
            eventData.preventDefault();
            return false;
        }
    }

    onOTPReceive(elem: HTMLInputElement, eventType: string, digit2?: HTMLInputElement) {
        const osType = this.analyticsService.GetDeviceDetails().os.toLowerCase();
        const isMobileFlag = this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.IsMobile);
        if ((osType === 'android' || osType === 'ios' || isMobileFlag === '1') && !this.isOtpPasted) {
            let digitValue;
            if (eventType === 'input' && elem.value) {
                // setTimeout(() => {
                elem.setAttribute('maxlength', '6');
                digitValue = elem.value;
                elem.value = digitValue.substr(0, 1);
                this.healthOtpForm.controls['digit1'].setValue(elem.value);
                elem.setAttribute('maxlength', '1');
                if (/\d{6}/.test(digitValue)) {
                    this.setOTPValue(digitValue);
                }
                if (digit2) {
                   digit2.focus({ preventScroll: true });
                }
                this.isOtpPasted = false;
                // }, 50);
            } else if (eventType === 'click' || eventType === 'focus') {
                elem.setAttribute('maxlength', '6');
            } else if (eventType === 'blur') {
                elem.setAttribute('maxlength', '1');
            }
        }
    }

    bothDOBHasError() {
        const formData = { ...this.SelectInsurerFormGroup.value };

        if (formData.day && formData.month && formData.year) {
            const DOBObj = {
                Day: formData.day,
                Month: formData.month,
                Year: formData.year
            };

            const dobDate = new Date(DOBObj.Year, DOBObj.Month, DOBObj.Day);
            if (this.GetGoingFormGroup.get('day').value && this.GetGoingFormGroup.get('month').value &&
                this.GetGoingFormGroup.get('year').value) {
                const formDataProposer = { ...this.GetGoingFormGroup.value };
                const proposalDOBObj = {
                    Day: formDataProposer.day,
                    Month: formDataProposer.month,
                    Year: formDataProposer.year
                };
                const proposerDob = new Date(proposalDOBObj.Year, proposalDOBObj.Month, proposalDOBObj.Day);
                if (this.MembersAddedToList.indexOf('Father') !== -1 ||
                    this.MembersAddedToList.indexOf('Mother') !== -1 ||
                    this.MembersAddedToList.indexOf('Spouse') !== -1) {
                    if (dobDate > proposerDob) {
                        this.serviceMessage = 'Eldest Member Date of birth can\'nt be less than Proposer Date of birth';
                        this.hasDobError = true;
                    } else {
                        this.serviceMessage = '';
                        this.hasDobError = false;
                    }
                } else {
                    this.serviceMessage = '';
                    this.hasDobError = false;
                }
                return this.hasDobError;
            }

        }
    }

    public Next() {

        // if (this.bothDOBHasError()) {
        //     return;
        // }

        if (this.GetGoingFormGroup.valid) {
            const payload = this.createPayload();
            this.showLoader = true;
            this._GetGoingCall.PostCallService(payload).subscribe((response) => {
                this.googleAnalyticGetQuote();
                const Payload = response.payload;
                const Haserror = response.errors;
                this.setUserAuthToken(response);
                if (Payload && Payload !== undefined) {
                    // set the quotes id for calling polling endpoint
                    if (Payload) {
                        this.setQuotesIs(Payload);
                    }
                    const appId = response.payload.applicationId;
                    this.appQuoteCriteriaId = response.payload.appQuoteCriteriaId;

                    const appIdFromCookie = + this._cookieHandler.GetCookie(CommonConstants.CookieKeys.applicationId, appId);
                    if (((appId === appIdFromCookie) && appId && appIdFromCookie)
                        && !this._analyticsService.GetDeviceDetails().mobile) {
                        this.routeHandlerService.RouteToNextTask('multitabfailed');
                        return;
                    }
                    this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.applicationId, response.payload.applicationId);
                    this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.groupHealthEligible,
                        response.payload.groupHealthEligible);
                    this._cookieHandler.SetCookie(CommonConstants.CookieKeys.applicationId, response.payload.applicationId,
                        response.payload.applicationId);

                    if (response.nextTask && response.nextTask.nextTaskKey === CommonConstants.Routes.Application.JourneyOtpVerification) {
                        this.mobileNumber = this.GetGoingFormGroup.get('mobileNumber').value;
                        this.generateOTP(this.onResendOTPReceived);
                        this.showLoader = false;
                        document.body.scrollTop = 0;
                        document.documentElement.scrollTop = 0;
                    } else {
                        this.routeHandlerService.RouteToNextTask(response.nextTask.nextTaskKey);
                    }
                } else {
                    this.isServiceError = true;
                    this.showLoader = false;
                    if (response) {
                        response.forEach(element => {
                            if (CommonConstants.serviceError.includes(element.errorCode)) {
                                this.serviceMessage = element.errorMessage;
                            }
                            else if (element.errorCode == 'APDM-907') {
                                this.showDrawer('commonErrorMessageDrawer', element.errorMessage)
                            }
                            else if (!this.bflJourney && element[0].errorCode == '401 UNAUTHORIZED') {
                                this.serviceMessage = 'The selected plan is currently unavailable. Please try after sometime';

                            } else {
                                this.serviceMessage = 'Something went wrong. Please try again later';
                            }
                        });
                    }
                }
            },
                (error) => {
                    this.showLoader = false;
                });
        } else {
            this.GetGoingFormGroup.markAllAsTouched();
        }
    }
    public setQuotesIs(Payload) {
        this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.planQuoteCriteriaData, JSON.stringify(Payload));
    }
    /* Back to same page on cancel */
    public Cancel($event) {
        this.getModalDirectiveInstanceBasedOnId(this.AnswerConfirmationPopupData.Id).hide();
    }

    // Validate Mobile Number
    public ValidateMobile() {
        const mobileNo = this.GetGoingFormGroup
            .controls['mobileNumber'].value.toString();
        const test = /(\d)\1{9}/g;
        if (mobileNo && !this.FormValidators.FieldHasErrors(
            this.GetGoingFormGroup, 'mobileNumber')) {
            if (mobileNo[0] === '6' || mobileNo[0] === '7' || mobileNo[0] === '8' || mobileNo[0] === '9') {
                this.IsCorrectMobile = null;
                this.IsValid = true;
                // if (this.bflJourney)
                //     this.GetWhatsappConsent();
            } else {
                if (mobileNo.length === 10) {
                    this.IsCorrectMobile = 'Mobile number should start with 6, 7, 8, 9';
                    this.IsValid = false;
                }
            }
            if (mobileNo.match(test)) {
                this.IsCorrectMobile = 'Please provide valid mobile number.';
            }
        } else {
            this.IsCorrectMobile = null;
        }
    }
    // DOB validation
    public ValidateDOB(updatedValue) {
        if (!this.SelectInsurerFormGroup) { return null; }
        const formData = { ...this.SelectInsurerFormGroup.value, ...updatedValue };

        if (formData.day && formData.month && formData.year) {
            let validationErr = null;
            const DOBObj = {
                Day: formData.day,
                Month: formData.month,
                Year: formData.year
            };

            this.DOB_DATE_RANGES = {
                MaxAge: 85,
                MinAge: 18
            };

            const error = this.FormValidators.IsDateOfBirthValid(DOBObj, null, this.DOB_DATE_RANGES.MinAge, this.DOB_DATE_RANGES.MaxAge);
            if (error) {
                console.log(error);
                return { rangeError: error };
            } else {
                const currDate = new Date();
                const dobDate = new Date(DOBObj.Year, DOBObj.Month, DOBObj.Day);
                if (currDate < dobDate) {
                    validationErr = { rangeError: 'Date of birth can\'nt be more than current date' };
                }


                // check proposal dob with eldest dob

                // if (this.GetGoingFormGroup.get('day').value && this.GetGoingFormGroup.get('month').value &&
                //     this.GetGoingFormGroup.get('year').value) {
                //     const formDataProposer = { ...this.GetGoingFormGroup.value };
                //     const proposalDOBObj = {
                //         Day: formDataProposer.day,
                //         Month: formDataProposer.month,
                //         Year: formDataProposer.year
                //     };
                //     const proposerDob = new Date(proposalDOBObj.Year, proposalDOBObj.Month, proposalDOBObj.Day);
                //     if (dobDate > proposerDob) {
                //         validationErr = { rangeError: 'Eldest Member Date of birth can\'nt be less than Proposer Date of birth' };
                //     }
                // }

            }
            const cl = Object.keys(updatedValue)[0];
            ['year', 'month', 'day']
                .filter(c => c !== cl)
                .forEach(c => this.SelectInsurerFormGroup.controls[c].setErrors(validationErr));
            return validationErr;
        }


    }

    public ValidateProposerDOB(updatedValue) {
        this.DOB_DATE_RANGES = {
            MaxAge: 85,
            MinAge: 18
        };
        return this.FormValidators.validateDobFormatter(updatedValue, this.GetGoingFormGroup, this.DOB_DATE_RANGES);
    }




    // Pin code change function.
    public OnPincodeChange($event) {
        this.validatePIN = false;
        this.GetGoingFormGroup.controls['pinCode'].setErrors({ 'incorrect': true });
        // latestPinCode logic is added to avoid the pincode service call getting fired on every keyup event
        if (this.latestPinCode !== this.GetGoingFormGroup.controls['pinCode'].value) {

            this.latestPinCode = this.GetGoingFormGroup.controls['pinCode'].value;
            this._pincodeService.OnPinCodeChanged($event, () => {
                if (this._pincodeService.GeoLocationDetails) {
                    this.GetGoingFormGroup.controls['pinCode']
                        .setValue(this._pincodeService.GeoLocationDetails.pinCode);
                    this.GetGoingFormGroup.controls['pinCode'].setErrors(null);
                    this.GetGoingFormGroup.controls['state'].setValue(
                        this._pincodeService.GeoLocationDetails.city.concat(
                            ', ', this._pincodeService.GeoLocationDetails.stateShortName)
                    );
                    console.log(this.GetGoingFormGroup);
                    // this.updateAreaCompleterUrl();
                    this.cityName = this._pincodeService.GeoLocationDetails.city;
                    this.validatePIN = true;
                } else {
                    this.GetGoingFormGroup.controls['pinCode'].setValue('');
                    this.GetGoingFormGroup.controls['state'].setValue('');
                }
            });
        }
        console.log(this.GetGoingFormGroup);
    }

    public prevent(event) {
        if (event.keyCode === 13) {
            event.preventDefault();
            return false;
        }
    }

    public ShowChildModal(id: string, contentType?: string): void {
        if (contentType) {
            this.initContentPopup();
        }
        this.getModalDirectiveInstanceBasedOnId(id).show();
    }
    public HideChildModal(id: string): void {
        this.getModalDirectiveInstanceBasedOnId(id).hide();
    }
    /*** Click on tab click for login info */
    public clickTab(item) {
        this.tabClick = item;
    }
    public toggleAns(i) {
        if (this.FAQS[i].isOpen) {
            this.FAQS[i].isOpen = false;
        } else {
            this.FAQS[i].isOpen = true;
        }
    }


    // ---------------------------- otp ----------------------------

    public generateOTP(callback): void {
        this.openDrawer('resumeOtpDrawer');
        const outputPayload = this.getFormValuesAsPayload();
        outputPayload['otp'] = CommonConstants.DEFAULT_EMPTY_STRING;
        outputPayload['source'] = CommonConstants.SourceTypes.Journey;
        outputPayload['mfa'] = true;
        outputPayload['notificationTypeCode'] = 'IMHLTHMOBILEOTP';
        this._GetGoingCall.postSendMobileOTP(outputPayload).subscribe(
            response => {
                if (!response.errorBean) {
                    this.isTimerStarted = true;
                    this.startClockTimer();
                    callback.call(this, response);
                } else if (CommonConstants.errorCodes.includes(response.errorBean[0].errorCode)) {
                    this.IsOTPResend = false;
                    this.ServiceError = response.errorBean[0].errorMessage;
                }
            },
            err => {
            }
        );
    }


    public buildHealthOtpForm() {
        this.healthOtpForm = this._formBuilder.group({
            digit1: ['', Validators.compose([Validators.required])],
            digit2: ['', Validators.compose([Validators.required])],
            digit3: ['', Validators.compose([Validators.required])],
            digit4: ['', Validators.compose([Validators.required])],
            digit5: ['', Validators.compose([Validators.required])],
            digit6: ['', Validators.compose([Validators.required])],
        });



        this.healthOtpForm.valueChanges.pipe(startWith(undefined), pairwise())
            .subscribe(valuesArray => {
                const newVal = valuesArray[1];
                const oldVal = valuesArray[0];
                if (JSON.stringify(newVal) !== JSON.stringify(oldVal) && this.healthOtpForm.valid) {
                    this.googleAnalyticOtpTime('6');
                    this.validateOtp();
                }
            })


    }


    public validateOtp() {
        if (!this.healthOtpForm.valid) {
            this.wrongOtpMsg = 'Please provide a valid OTP.';
        } else {
            this.IsOTPResend = false;
            const outputPayload = this.createOtpPayload();
            if (this.mobileOtpTrails >= 5) {
                this.resendOtpExceedFlag = true;
            }
            this.showLoader = true;
            this._GetGoingCall.postValidateOTP(outputPayload)
                .subscribe((mtResponse: ActivitiModel.MTResponse<any>) => {
                    this.showLoader = false;
                    this.ServiceOTPError = null;
                    if (mtResponse.payload && mtResponse.payload.tokens) {
                        this.wrongOtpMsg = null;
                        this.googleAnalyticSubmitOtp(true);
                        const token = mtResponse.payload.tokens[0].token;
                        if (token) {
                            this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.JWToken, token);
                        }
                        this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.GuardKey,
                            token.guardKey);
                        this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.GuardToken,
                            this.formatter.ConvertGuradKeyToGuardToken(token.guardKey));
                        this.navigateToNextTask();
                    } else {
                        this.googleAnalyticSubmitOtp(false);
                    }
                    if ((!!mtResponse.errorBean && CommonConstants.errorCodes.includes(mtResponse.errorBean[0].errorCode)) || mtResponse.error.errorBean[0].errorCode) {
                        this.mobileOtpTrails++;
                        if (mtResponse.errorBean && mtResponse.errorBean[0].errorMessage)
                            this.ServiceOTPError = mtResponse.errorBean[0].errorMessage;
                        if (mtResponse.error && mtResponse.error.errorBean && mtResponse.error.errorBean[0].errorCode)
                            this.ServiceOTPError = 'Please provide a valid OTP.';
                    } else {
                        this.mobileOtpTrails++;
                    }
                },
                    (err) => {
                        this.googleAnalyticSubmitOtp(false);
                        this.showLoader = false;
                        this.mobileOtpTrails++;
                        this.wrongOtpMsg = 'Please provide a valid OTP.';
                    });
        }
    }


    public resendOTP(formValue?: FormData) {
        this.healthOtpForm.reset();
        this.IsOTPResend = false;
        if (this.resendOTPCount < 5) {
            this.timerOn = false;
            this.startClockTimer();
            this.timerOn = true;
            this.otpCountDown(60);

            this.generateOTP(this.onResendOTPReceived);

            this.IsOTPResend = true;
            this.resendOTPCount++;
        } else {
            this.resendOtpExceedFlag = true;
        }
    }

    public navigateToNextTask() {
        this.showLoader = true;
        this._moreAboutYouCall.PostCallService({ 'action': 'next' }, 'nomineeDetails').subscribe((response: any) => {
            clearTimeout(this.setTime);
            clearTimeout(this.timer);
            this.showLoader = false;
            if (response.nextTask) {
                if (response) {
                    const Payload = response.payload;
                    this.setQuotesIs(Payload);
                }
                this.routeHandlerService.RouteToNextTask(response.nextTask.nextTaskKey);
            } else {
                this.routeHandlerService.RouteToNextTask(response.nextTaskKey);
            }
        },
            (error) => {
                this.ServiceError = 'Something went wrong. Please try again later';
                this.showLoader = false;
            });
    }

    // open drawer
    public openDrawer(itemId) {
        if (itemId === 'resumeOtpDrawer') {
            this.isTimerStarted = true;
            this.startClockTimer();
            document.getElementById('custom-header').style.display = 'none';
            this.showOtpDrawer = true;
            this.timerOn = true;
            this.otpCountDown(60);
        }
        if (itemId === 'insuringForDrawer') {
            this.startInsuringForTimer();
            if (this.MembersAddedToList && (this.MembersAddedToList.length === 0)) {
                const formControls = this.getDefaultInsuringForList();
                this.GetGoingFormGroup.patchValue({
                    insuredMembers: this.MembersAddedLable
                });
                this.insurerCountCheck();
                this.SelectInsurerFormGroup.controls['insurer'] = new FormArray(formControls);
            }
            if (this.MembersAddedToList && (this.MembersAddedToList.length === 1) && this.MembersAddedToList[0] === 'Self') {
                this.SelectInsurerFormGroup.patchValue({ 'insurer': [true] });
            }
            this.SelectInsurerFormGroup.updateValueAndValidity();
        }
        this.drawer.filter((item, index) => {
            return (itemId === item.drawerId);
        })[0].open();
    }

    // close drawer
    public hideDrawer(itemId) {

        const selectedDrawer = this.drawer.filter((item, index) => {
            return (itemId === item.drawerId);
        });
        this.timerOn = false;
        if (!!selectedDrawer && selectedDrawer.length > 0) {
            selectedDrawer[0].close();
        }
    }

    public startClockTimer() {
        clearTimeout(this.setTime);
        this.setTime = setTimeout(() => {
            this.isTimerStarted = false;
        }, 60000);
    }
    public onbackdrop() {
        this.timerOn = false;
    }


    // check for mobileNum eligible for whatsapp consent or not
    public GetWhatsappConsent() {
        const mobile = this.GetGoingFormGroup.controls['mobileNumber'].value;
        const requestPayload = {
            mobileno: mobile
        };
        if (mobile && this.GetGoingFormGroup.controls['mobileNumber'].valid && !this.IsCorrectMobile) {
            this._whatsappConsentService.GetConsent(requestPayload).subscribe((response) => {
                if (response.payload.cnsentflg == null || response.payload.cnsentflg === 0) {
                    this.ShowConsent = true;
                    this.checkUserConsent();
                } else {
                    this.ShowConsent = false;
                }
                console.log('response', response);
            });
        }
    }

    //  check for consent status
    public checkUserConsent() {
        const mobile = this.GetGoingFormGroup.controls['mobileNumber'].value;
        console.log('consent', this.whatsAppConsent);
        let whatsAppConsent: number;
        this.whatsAppConsent ? whatsAppConsent = 1 : whatsAppConsent = 0;
        const requestPayload = {
            'cnsentflg': whatsAppConsent,
            'consentChannel': 'WhatsApp',
            'consentIp': '',
            'consentProviderType': 'Customer',
            'consentUrl': null,
            'consentdt': this.today,
            'consentsource': 'Digital Platform',
            'deviceId': null,
            'email': null,
            'mobileno': mobile,
            'revokedt': null,
            'userkey': null,
            'applicationId': this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId)
        };
        this._whatsappConsentService.AddConsent(requestPayload).subscribe((response) => {
            console.log('response', response);
        });
        this.googleAnalyticTabOut();
    }

    public OnGenderSelection(event) {
        this.selectedGender = GENDER_LIST.find(gl => gl === event);
    }

    public onKeydown(event, prevInput, nextInput) {
        setTimeout(() => {

            if (event.key === 'ArrowLeft' || event.key === 'Backspace') {
                prevInput.focus({ preventScroll: true });
            }
            if (event.key === 'ArrowRight') {
                nextInput.focus({ preventScroll: true });
            }
        }, 50);
    }

    public isMobile() {
        return (window.innerWidth < 767) ? true : false;
    }
    public onDown(event, nextInput) {
        if (event.keyCode === 9) {
            // (<HTMLInputElement>document.getElementById('gender_0')).checked = true;
            this.GetGoingFormGroup.patchValue({
                gender: 'Male'
            });

        }
        if (event.keyCode === 27) {
            if (this.selectedGender === "Male") {
                this.curr_gender = "Male";
            }
            else if (this.selectedGender === "Female") {
                this.curr_gender = "Female";
            }
            this.GetGoingFormGroup.patchValue(
                {
                    gender: ''
                });
            this.selectedGender = "false";

        }
        // this.selectedGender = this.GetGoingFormGroup.controls['gender'].value;
    }
    public onSpace(event, prevInput, nextInput) {

        if (event.keyCode === 32) {
            event.preventDefault();
            if ((<HTMLInputElement>document.getElementById('gender_0')).checked === true) {
                this.curr_gender = "Male";
                (<HTMLInputElement>document.getElementById('gender_0')).checked = false;
                this.selectedGender = "false";
                console.log("male is deselected");
                if ((<HTMLInputElement>document.getElementById('gender_0')).checked === false) {

                    console.log("its false");



                }

                this.s = "Male";
                event.stopPropagation();

            }
            else if (this.s === "Male") {
                (<HTMLInputElement>document.getElementById('gender_0')).checked = true;
                event.stopPropagation();


            }


        }


    }

    public toggleFemale(event, prevInput, nextInput) {
        if (event.keyCode === 32) {
            event.preventDefault();
            if ((<HTMLInputElement>document.getElementById('gender_1')).checked === true) {
                this.curr_gender = "Female";
                (<HTMLInputElement>document.getElementById('gender_1')).checked = false;
                this.selectedGender = "false";
                console.log("female is deselected");
                if ((<HTMLInputElement>document.getElementById('gender_1')).checked === false) {

                    console.log("its false");



                }

                this.s = "Female";
                event.stopPropagation();

            }
            else if (this.s === "Female") {
                console.log("hello2");
                (<HTMLInputElement>document.getElementById('gender_1')).checked = true;
                event.stopPropagation();
            }
        }

    }
    public onEnter(event) {
        if (event.keyCode === 13) {
            if (this.curr_gender === "Male") {
                (<HTMLInputElement>document.getElementById('gender_0')).checked = true;
            }
            else if (this.curr_gender === "Female") {
                (<HTMLInputElement>document.getElementById('gender_1')).checked = true;
            }
        }
    }
    public scrollDown($event) {
        const input = $event.target;
        const maxLength = input.attributes.maxlength.value;
        const length = input.value.length;
        if (length >= maxLength) {
            window.scrollTo(0, 300);
        }
    }


    private onResendOTPReceived(mtResponse: ActivitiModel.MTResponse<any>) {
        if (mtResponse.errorBean) {
            this.IsServiceFailure = true;
        }
    }
    private createOtpPayload() {
        const formValue = this.GetGoingFormGroup.value;
        const d = parseInt(formValue['day'], 10);
        const m = parseInt(formValue['month'], 10);
        const day = d < 10 ? '0' + d : d;
        const month = m < 10 ? '0' + m : m;
        this.dobforotp = formValue['year'] + '-' + month + '-' + day;
        const InsProductType = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.InsProductType);
        const outputPayload = {
            "applicationKey": this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId),
            "dateOfBirth": null,
            "mobile": this.mobileNumber,
            "otp": this.healthOtpForm.controls['digit1'].value + this.healthOtpForm.controls['digit2'].value +
                this.healthOtpForm.controls['digit3'].value + this.healthOtpForm.controls['digit4'].value +
                this.healthOtpForm.controls['digit5'].value + this.healthOtpForm.controls['digit6'].value,
            "productcatcode": InsProductType ? InsProductType : 'HGI',
            "source": 'journey',
            "stage": null
        }
        return outputPayload;
    }

    private getFormValuesAsPayload(isActivityCall?: boolean) {
        const outputPayload = {};
        outputPayload['mobile'] = this.mobileNumber;
        outputPayload['productCode'] = CommonConstants.LOAN_PRODUCT_CODES.Health_Insurance;
        outputPayload['insProductType'] = CommonConstants.InsProductType;
        return outputPayload;
    }

    private UtmStamping() {
        let campaignCookie: any;
        if (this._cookieHandler.GetCookie('campaignCookie') && this._cookieHandler.GetCookie('campaignCookie') !== null) {
            campaignCookie = JSON.parse(this._cookieHandler.GetCookie('campaignCookie'));
        }
        let UTM = this._sharedService.getData('UTM');
        UTM = UTM.split(':');
        if (UTM.length === 1) { UTM.length = []; }
        const utmSource = this._routeContextProvider.GetQueryParams('utm_source') ?
            this._routeContextProvider.GetQueryParams('utm_source') :
            ((campaignCookie && campaignCookie['utm_source']) ? campaignCookie['utm_source'] : 'Organic');
        const utmMedium = this.isMobileFlag ? this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.utm_medium_3in1) :
            (this._routeContextProvider.GetQueryParams('utm_medium') ? this._routeContextProvider.GetQueryParams('utm_medium') :
                ((campaignCookie && campaignCookie['utm_medium']) ? campaignCookie['utm_medium'] : null));
        const utmCampaign = this._routeContextProvider.GetQueryParams('utm_campaign') ? this._routeContextProvider.GetQueryParams('utm_campaign') :
            ((campaignCookie && campaignCookie['utm_campaign']) ? campaignCookie['utm_campaign'] : null);
        const utmContent = this._routeContextProvider.GetQueryParams('utm_content') ? this._routeContextProvider.GetQueryParams('utm_content') :
            ((campaignCookie && campaignCookie['utm_content']) ? campaignCookie['utm_content'] : null);
        const utmTerm = this._routeContextProvider.GetQueryParams('utm_term') ? this._routeContextProvider.GetQueryParams('utm_term') :
            ((campaignCookie?.utm_term) ? campaignCookie?.utm_term : null);
        const sourcing = {
            'utmSource': utmSource,
            'utmMedium': utmMedium,
            'utmCampaign': utmCampaign,
            'utmContent': utmContent,
            'utmTerm': utmTerm,
            'gclId': this.visitorID ? this.visitorID : null,
            "recVersion": 1
        };
        this.setrolekey(UTM);
        return sourcing;
    }

    private setrolekey(UTM) {
        if (UTM.length && UTM[1] === 'Callcentre' && !isNaN(+UTM[4])) {
            this.resultKey = +UTM[4];
        } else {
            this.resultKey = null;
        }
    }

    private initContentPopup() {
        this.ContentPopup = {
            Id: 'content-modal',
            Title: 'Riders',
            Config: <CustomModalOptions>{ show: false, closeOption: true }
        };
    }

    private getModalDirectiveInstanceBasedOnId(popupId: string): any {
        return this.PopupComponent.filter((item: PopupComponent, index: number) => {
            return item.id === popupId;
        })[0].modalControl;
    }

    private setUserAuthToken(responseData: any) {
        if (responseData.nextTask && responseData.nextTask !== null && responseData.nextTask !== ''
            && responseData.nextTask.nextTaskKey !== 'rejectApp') {
            this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.processId,
                responseData.nextTask.processId);
        }

        if (responseData.payload && responseData.payload !== null && responseData.payload !== '') {
            /* If application Id is different then set selectedQuoteId to 0 */
            const applicationId = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId) ?
                this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId) :
                null;
            if (applicationId && applicationId !== responseData.payload.applicationId) {
                this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.selectedQuoteId, 0);
            }
        }
        if (responseData.payload && responseData.payload !== null && responseData.payload !== '') {
            this._sessionHandlerService.
                SetSession(CommonConstants.CookieKeys.applicationId,
                    responseData.payload.applicationId);
        }
        if (responseData.headers) {
            const authToken = responseData.headers.get('authtoken');
            if (authToken !== null && authToken !== '') {
                this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.JWToken, authToken);
            }
        }
        if (responseData.headers) {
            const sessionToken = responseData.headers.get('X-Session-Token');
            if (sessionToken !== null && sessionToken !== '') {
                this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.sessionId, sessionToken);
            }
        }

        this._currentRoute.url.forEach(url => {
            if (url.toString() != CommonConstants.Routes.Application.GetGoingNowEdit) {
                const epToken = this._cookieHandler.GetCookie(CommonConstants.CookieKeys.JWTokenEP);
                if (epToken) {
                    this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.JWToken, epToken);
                    this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.GuardKey, this._cookieHandler.GetCookie(CommonConstants.CookieKeys.GuardKeyEP));
                    this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.GuardToken, this.formatter
                        .ConvertGuradKeyToGuardToken(this._cookieHandler.GetCookie(CommonConstants.CookieKeys.GuardTokenEP)));
                }
            }
        });
    }


    private createPayload() {
        this.ShowOnlyGroupPlan = this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.ShowOnlyGroupPlan) ? JSON.parse(this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.ShowOnlyGroupPlan)) : false;
        this.insuringFor = 'Individual';
        const formValue = this.GetGoingFormGroup.value;
        const d = parseInt(formValue['day'], 10);
        const m = parseInt(formValue['month'], 10);
        const day = d < 10 ? '0' + d : d;
        const month = m < 10 ? '0' + m : m;
        const dobProposer = formValue['year'] + '-' + month + '-' + day;

        const formValueInsurer = this.SelectInsurerFormGroup.value;
        const d1 = parseInt(formValueInsurer['day'], 10);
        const m1 = parseInt(formValueInsurer['month'], 10);
        const day1 = d1 < 10 ? '0' + d1 : d1;
        const month1 = m1 < 10 ? '0' + m1 : m1;
        this.dobEldest = formValueInsurer['year'] + '-' + month1 + '-' + day1;

        if ((this.MembersAddedToList.length === 1 && this.MembersAddedToList.includes('Self')) ||
            (this.MembersAddedToList.indexOf('Father') < 0 &&
                this.MembersAddedToList.indexOf('Mother') < 0 && this.MembersAddedToList.indexOf('Spouse') < 0)) {
            this.dobEldest = dobProposer;
        }


        console.log(this.MembersAddedToList);

        const memberList = [];
        this.MembersAddedToList.forEach(element => {
            memberList.push({
                'no': element === 'Self' || element === 'Spouse' ? 0 : 1,
                'relationship': element,
            });
        });

        if (this.MembersAddedToList.length > 1) {
            this.insuringFor = 'Family';
        } else {
            this.insuringFor = 'Individual';
        }

        let UTM = this._sharedService.getData('UTM');
        UTM = UTM.split(':');
        let tabKey, roleKey, userKey;
        const epUserDetails = this.decodeEPObject(CommonConstants.CookieKeys.epUserDetails);
        if (epUserDetails && epUserDetails.roleKey) {
            roleKey = epUserDetails.roleKey;
            userKey = epUserDetails.userKey;
        }
        const epTokenDetails = this.decodeEPObject(CommonConstants.CookieKeys.epTokenDetails);
        if (epTokenDetails && epTokenDetails.tabKey) {
            tabKey = epTokenDetails.tabKey;
        }
        let demogDobResponse = this.demogApiResponse?.dob;
        // if (demogDobResponse) {
        //     if (demogDobResponse.includes('-')) {
        //         demogDobResponse = demogDobResponse.split('-').reverse().join('/');
        //     }
        // }

        const InsProductType = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.InsProductType);
        const Payload = {
            'payload': {
                'tabKey': tabKey ? tabKey : null,
                'roleKey': roleKey ? roleKey : null,
                'userKey': userKey ? userKey : null,
                'mobile': this.GetGoingFormGroup.controls['mobileNumber'].value,
                'cityKey': this._pincodeService.GeoLocationDetails.cityId,
                'pincodeKey': this._pincodeService.GeoLocationDetails.pinId,
                'productCategoryCode': InsProductType ? InsProductType : 'HGI',
                'assetDetailReq': false,
                'applicationUTMParams': this.UtmStamping(),
                'userrolekey': this.resultKey !== null ? this.resultKey.toString() : null,
                'tcApplicationFlag': 1,
                'quoteCriteria': {
                    'hGIQuoteCriteria': {
                        'applicationId': null,
                        'insuranceDetails': {
                            'pinCode': this.GetGoingFormGroup.controls['pinCode'].value,
                            // 'insuringFor': this.insuringFor,
                            'insuringFor': 'Self',
                            // 'dobEldestMember': this.dobEldest,
                            'dobEldestMember': demogDobResponse ? demogDobResponse : '1991-10-07',
                            'firstName': this.formatter.GetName('first', formValue['proposerName']),
                            'middleName': this.formatter.GetName('middle', formValue['proposerName']),
                            'lastName': this.formatter.GetName('last', formValue['proposerName']),
                            // 'dobProposal': dobProposer,
                            // 'gender': this.selectedGender,
                            'dobProposal': demogDobResponse ? demogDobResponse : '1991-10-07',
                            // 'gender': this.selectedGender ? this.selectedGender : 'Male',
                            'gender': this.demogApiResponse?.gender ? this.demogApiResponse?.gender : 'Male',
                            'policyTenor': 1
                        },
                        'showOnlyGroupPlan': this.ShowOnlyGroupPlan,
                        'insuredDetails': memberList,
                        'medicalDeclaration': false,
                    }
                },
            }
        };
        return Payload;
    }

    private buildFormGroup() {
        let formControls;
        const dobValidation = (name) => (control: FormControl) => this.ValidateDOB({ [name]: control.value });
        const proposerDobValidation = (name) => (control: FormControl) => this.ValidateProposerDOB({ [name]: control.value });

        const mustHaveLastName = (control: FormControl) => {
            return !control.value?.trim() || control.value?.trim().includes(' ')
                ? null
                : { lastNameMandatory: true };
        };

        this.GetGoingFormGroup = this._formBuilder.group({
            proposerName: ['', Validators.compose([Validators.required, mustHaveLastName, this.formatter.removeSpaces])],
            // gender: ['', Validators.compose([Validators.required])],
            mobileNumber: ['', Validators.compose([Validators.required])],
            pinCode: ['', Validators.compose([Validators.required])],
            state: [{ value: '', disabled: true }],
            // day: ['', Validators.compose([Validators.required, proposerDobValidation('day')])],
            // month: ['', Validators.compose([Validators.required, proposerDobValidation('month')])],
            // year: ['', Validators.compose([Validators.required, proposerDobValidation('year')])],
            insurerName: [''],
            // insuredMembers: [''],
        });
        // if (!this.backFlow) {
        formControls = this.getDefaultInsuringForList();
        this.GetGoingFormGroup.patchValue({
            insuredMembers: this.MembersAddedLable
        });
        this.insurerCountCheck();
        // } else {
        //     formControls = this.InsuredMemberList.map(control => new FormControl(false));
        // }
        const OtherMemberformControls = this.InsuredOtherMemberList.map(control => new FormControl(false));

        this.SelectInsurerFormGroup = this._formBuilder.group({
            insurer: new FormArray(formControls),
            son: ['', Validators.compose([])],
            daughter: ['', Validators.compose([])],
            otherInsurer: new FormArray(OtherMemberformControls),
            day: ['', Validators.compose([Validators.required, dobValidation('day'), Validators.min(1), Validators.max(31)])],
            month: ['', Validators.compose([Validators.required, dobValidation('month'), Validators.min(1), Validators.max(12)])],
            year: ['', Validators.compose([Validators.required, dobValidation('year')])],
        });


        // this.GetGoingFormGroup.valueChanges.subscribe(() => {
        //     if (this.isProposerDobValid() && !(this.checkDOBValid())) {
        //         this.SelectInsurerFormGroup.patchValue({
        //             day: this.GetGoingFormGroup.get('day').value,
        //             month: this.GetGoingFormGroup.get('month').value,
        //             year: this.GetGoingFormGroup.get('year').value
        //         });
        //     }
        // });
        this.isMobileFlag = this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.IsMobile) === '1';
        this._sessionHandlerService.SetSession(CommonConstants.QueryParamsKeys.IsMobile, this.isMobileFlag);
        if (this.isMobileFlag) {
            this.setUserInput();
        }
        this.insuringMemberList = [...this.MembersAddedToList];
        this.insuringMemberLable = this.MembersAddedLable;
        this.FormValidators.subscribeToValueChanges(this.GetGoingFormGroup);
    }

    isProposerDobValid() {
        return (this.GetGoingFormGroup.controls['day'].valid && this.GetGoingFormGroup.controls['month'].valid
            && this.GetGoingFormGroup.controls['year'].valid);
    }




    //  insuring for

    public patchInsuringFor() {
        this.MembersAddedToList = [...this.insuringMemberList];
        this.MembersAddedLable = this.insuringMemberLable;
        let formControls = this.InsuredMemberList.map((member) => {
            let formValue = new FormControl(false);
            this.MembersAddedToList.forEach(element => {
                if (element.toLowerCase() === member.title.toLowerCase()) {
                    formValue = new FormControl(true);
                }
            });
            return formValue;
        });
        let OtherMemberformControls = this.InsuredOtherMemberList.map((member) => {
            let formValue = new FormControl(false);
            this.MembersAddedToList.forEach(element => {
                if (element.toLowerCase() === member.title.toLowerCase()) {
                    formValue = new FormControl(true);
                }
            });
            return formValue;
        });
        if (this.MembersAddedToList && (this.MembersAddedToList.length === 0)) {
            this.MembersAddedToList = ['Self'];
            this.MembersAddedLable = 'Self';
            formControls = this.getDefaultInsuringForList();
            this.GetGoingFormGroup.patchValue({
                insuredMembers: this.MembersAddedLable
            });
            this.insurerCountCheck();
        }
        if (!this.MembersAddedToList.includes("son")) {
            this.SelectInsurerFormGroup.patchValue({
                son: ''
            });
        }
        if (!this.MembersAddedToList.includes("daughter")) {
            this.SelectInsurerFormGroup.patchValue({
                daughter: ''
            });
        }
        if (!this.MembersAddedToList.includes("Spouse") && !this.MembersAddedToList.includes("Father") && !this.MembersAddedToList.includes("Mother")) {
            this.SelectInsurerFormGroup.patchValue({
                day: '',
                month: '',
                year: ''
            });
        }
        this.SelectInsurerFormGroup.setControl('insurer', new FormArray(formControls));
        if (this.MembersAddedToList && (this.MembersAddedToList.length === 1) && this.MembersAddedToList[0] === 'Self') {
            this.SelectInsurerFormGroup.patchValue({ 'insurer': [true] });
        }
        this.SelectInsurerFormGroup.updateValueAndValidity();
        this.SelectInsurerFormGroup.setControl('otherInsurer', new FormArray(OtherMemberformControls));
        if (this.InsuranceDetails && this.InsuranceDetails.dobEldestMember) {
            this.formattedDOB = this.InsuranceDetails.dobEldestMember.split('-').reverse().join('/');
            const dobSplit = this.formattedDOB.split('/');
            const day = dobSplit[0];
            const month = dobSplit[1];
            const year = dobSplit[2];
            this.SelectInsurerFormGroup.controls['day'].setValue(day);
            this.SelectInsurerFormGroup.controls['month'].setValue(month);
            this.SelectInsurerFormGroup.controls['year'].setValue(year);
        }
        const firstLetterCaps = relationshipName => relationshipName.substr(0, 1).concat(
            relationshipName.substr(1, relationshipName.length).toLowerCase());
        let incomingSonCount = this.SelectedSonCount || 0, incomingDaughterCount = this.SelectedDaughterCount || 0;
        if (!this.SelectedSonCount) {
            this.SonCount = 0;
        }
        if (!this.SelectedDaughterCount) {
            this.DaughterCount = 0;
        }

        const insurerdResponse = this.InsurerdResponse;
        if (!this.SelectedSonCount || !this.SelectedDaughterCount) {
            insurerdResponse && insurerdResponse.length && insurerdResponse.forEach(insured => {
                if (insured.relationship.toLowerCase() === 'son') {
                    incomingSonCount++;
                } else if (insured.relationship.toLowerCase() === 'daughter') {
                    incomingDaughterCount++;
                } else {
                    this.MembersAddedToList.push(firstLetterCaps(insured.relationship));
                }
            });
        }
        if (incomingSonCount === 1) {
            this.MembersAddedToList.push(`${SON}`);
        } else if (incomingSonCount > 1) {
            this.MembersAddedToList.push(`${SON}(${incomingSonCount})`);
        }
        if (incomingDaughterCount === 1) {
            this.MembersAddedToList.push(`${DAUGHTER}`);
        } else if (incomingDaughterCount > 1) {
            this.MembersAddedToList.push(`${DAUGHTER}(${incomingDaughterCount})`);
        }
        this.DaughterCount = incomingDaughterCount;
        this.SonCount = incomingSonCount;
        this.MembersAddedLable = this.MembersAddedToList.join(', ');
        if (this.DaughterCount === 4) {
            this.SelectInsurerFormGroup.get('son').disable();
        } else {
            this.SelectInsurerFormGroup.get('son').enable();
        }
        if (this.SonCount === 4) {
            this.SelectInsurerFormGroup.get('daughter').disable();
        } else {
            this.SelectInsurerFormGroup.get('daughter').enable();
        }
        this.checkInsurerCheckboxes();
        this.SelectInsurerFormGroup.updateValueAndValidity();
    }

    public resetInsurerDate() {
        if ((this.MembersAddedToList.indexOf('Father') < 0 &&
            this.MembersAddedToList.indexOf('Mother') < 0 && this.MembersAddedToList.indexOf('Spouse') < 0)) {
            this.SelectInsurerFormGroup.patchValue({
                day: this.GetGoingFormGroup.get('day').value,
                month: this.GetGoingFormGroup.get('month').value,
                year: this.GetGoingFormGroup.get('year').value,
            });
        }

        // this.bothDOBHasError();
    }
    public checkInsurerCheckboxes() {
        const setFormDOMData = index => {
            this.SelectInsurerFormGroup.value.insurer[index] = true;
            (<HTMLInputElement>document.getElementById('insuredMember' + index)).checked = true;
            const insurer = this.SelectInsurerFormGroup.controls['insurer'];
            insurer['controls'][index].setValue(true);
        };
        const setFormDOMDataSD = (sondaughter, sondaughterCount) => {
            this.SelectInsurerFormGroup.value[sondaughter] = true;
            (<HTMLInputElement>document.getElementById(sondaughter)).checked = true;
            this.SelectInsurerFormGroup.controls[sondaughter].setValue(sondaughterCount ? true : false);
            this.lastDaughterCount = this.substracFromFour(this.SonCount);
            this.lastSonCount = this.substracFromFour(this.DaughterCount);
        };
        const setFormDOMDataOthers = index => {
            this.SelectInsurerFormGroup.value.otherInsurer[index] = true;
            (<HTMLInputElement>document.getElementById('insuredOtherMember' + index)).checked = true;
            const insurer = this.SelectInsurerFormGroup.controls['otherInsurer'];
            insurer['controls'][index].setValue(true);
        };
        for (let i = 0, incomingInsuredMembersArrayLen = this.MembersAddedToList.length;
            i < incomingInsuredMembersArrayLen; i++) {
            switch (this.MembersAddedToList[i].toLowerCase()) {
                case 'self':
                    setFormDOMData(0);
                    break;
                case 'spouse':
                    setFormDOMData(1);
                    break;
                case 'father':
                    setFormDOMDataOthers(0);
                    break;
                case 'mother':
                    setFormDOMDataOthers(1);
                    break;
                case 'father-in-law':
                    setFormDOMDataOthers(2);
                    break;
                case 'mother-in-law':
                    setFormDOMDataOthers(3);
                    break;
                default:
                    console.log('Invalid Insurer...!');
            }
            if (this.MembersAddedToList[i].toLowerCase().indexOf('son') > -1) {
                setFormDOMDataSD('son', this.SonCount);
            }
            if (this.MembersAddedToList[i].toLowerCase().indexOf('daughter') > -1) {
                setFormDOMDataSD('daughter', this.DaughterCount);
            }
        }
        this.createInsuringForList();
    }


    public substracFromFour(sonDaughtercount) {
        return 4 - sonDaughtercount;
    }

    public counter(i: number) {
        return new Array(i);
    }

    public triggerSonCheckbox() {

        const sonFormControl = this.SelectInsurerFormGroup.get('son');
        sonFormControl.setValue(!sonFormControl.value);

        // Check the value of 'son' and update SonCount and lastDaughterCount accordingly
        if (sonFormControl.value) {
            this.SonCount = 1;
        } else {
            this.SonCount = 0;
        }
        this.lastDaughterCount = this.substracFromFour(this.SonCount);

        // Call createInsuringForList
        this.createInsuringForList();

        // Check if 'son' is unchecked and enable 'daughter' if needed
        if (!sonFormControl.value) {
            this.SelectInsurerFormGroup.get('daughter').enable();
        }

    }

    public checkForSon(event) {
        if (!this.SelectInsurerFormGroup.value.son) {
            this.SonCount = 0;
            this.lastDaughterCount = this.substracFromFour(this.SonCount);
            this.createInsuringForList();
        } else {
            this.SonCount = 1;
            this.lastDaughterCount = this.substracFromFour(this.SonCount);
            this.createInsuringForList();
        }
        if (event.target.checked === false) {
            this.SelectInsurerFormGroup.get('daughter').enable();
        }
    }

    public checkForDaughter(event) {
        if (!this.SelectInsurerFormGroup.value.daughter) {
            this.DaughterCount = 0;
            this.lastSonCount = this.substracFromFour(this.DaughterCount);
            this.createInsuringForList();
        } else {
            this.DaughterCount = 1;
            this.lastSonCount = this.substracFromFour(this.DaughterCount);
            this.createInsuringForList();
        }
        if (event.target.checked === false) {
            this.SelectInsurerFormGroup.get('son').enable();
        }
    }

    public triggerDaughterCheckbox() {
        const daughterFormControl = this.SelectInsurerFormGroup.get('daughter');
        daughterFormControl.setValue(!daughterFormControl.value);

        // Check the value of 'daughter' and update DaughterCount and lastSonCount accordingly
        if (daughterFormControl.value) {
            this.DaughterCount = 1;
        } else {
            this.DaughterCount = 0;
        }
        this.lastSonCount = this.substracFromFour(this.DaughterCount);
        this.lastDaughterCount = this.substracFromFour(this.SonCount);

        // Call createInsuringForList
        this.createInsuringForList();

        // Check if 'daughter' is unchecked and enable 'son' if needed
        if (!daughterFormControl.value) {
            this.SelectInsurerFormGroup.get('son').enable();
        }
    }

    public ChangeSonCount(id: number, event: Event) {
        event.stopPropagation();
        this.SonCount = id;
        this.SelectInsurerFormGroup.controls['son'].setValue(this.SonCount ? true : false);
        this.lastSonCount = this.substracFromFour(this.DaughterCount);
        this.lastDaughterCount = this.substracFromFour(this.SonCount);
        if (this.SonCount === 4) {
            this.SelectInsurerFormGroup.get('daughter').disable();
        } else {
            this.SelectInsurerFormGroup.get('daughter').enable();
        }
        this.createInsuringForList();
    }



    public ChangeDaughterCount(id: number, event: Event) {
        event.stopPropagation();
        this.DaughterCount = id;
        this.SelectInsurerFormGroup.controls['daughter'].setValue(this.DaughterCount ? true : false);
        this.lastSonCount = this.substracFromFour(this.DaughterCount);
        this.lastDaughterCount = this.substracFromFour(this.SonCount);
        if (this.DaughterCount === 4) {
            this.SelectInsurerFormGroup.get('son').disable();
        } else {
            this.SelectInsurerFormGroup.get('son').enable();
        }
        this.createInsuringForList();
    }

    public createInsuringForList(indexValue?: number, input?: string) {


        let formArrayControls = (this.SelectInsurerFormGroup.get('insurer') as FormArray).controls;

        formArrayControls.forEach((control, i) => {
            if (indexValue === i && input === 'input2') {
                control.patchValue(!control.value);
            }
        })
        let formArrayControls2 = (this.SelectInsurerFormGroup.get('otherInsurer') as FormArray).controls;

        formArrayControls2.forEach((control, i) => {
            if (indexValue === i && input === 'input') {
                control.patchValue(!control.value);
            }
        })

        this.MembersAddedToList = this.SelectInsurerFormGroup.value.insurer
            .map((checked, index) => checked ? this.InsuredMemberList[index].title : null)
            .filter(value => value !== null);
        const OtherMembersAddedToList = this.SelectInsurerFormGroup.value.otherInsurer
            .map((checked, index) => checked ? this.InsuredOtherMemberList[index].title : null)
            .filter(value => value !== null);
        this.MembersAddedToList = this.MembersAddedToList.concat(OtherMembersAddedToList);
        this.MembersAddedLable = this.MembersAddedToList.join(', ');
        if (this.SelectInsurerFormGroup.value.son) {
            if (this.SonCount > 0) {
                this.MembersAddedLable += (this.MembersAddedLable === '' || this.MembersAddedLable.length === 0) ? 'Son' : ', Son';
            }
            this.MembersAddedLable += (this.SonCount > 1) ? '(' + this.SonCount + ')' : '';
            for (let index = 0; index < this.SonCount; index++) {
                this.MembersAddedToList.push('son');
            }
        }
        if (this.SelectInsurerFormGroup.value.daughter) {
            if (this.DaughterCount > 0) {
                this.MembersAddedLable += (this.MembersAddedLable === '' ||
                    this.MembersAddedLable.length === 0) ? 'Daughter' : ', Daughter';
            }
            this.MembersAddedLable += (this.DaughterCount > 1) ? '(' + this.DaughterCount + ')' : '';
            for (let index = 0; index < this.DaughterCount; index++) {
                this.MembersAddedToList.push('daughter');
            }
        }
        this.GetGoingFormGroup.patchValue({
            insuredMembers: this.MembersAddedLable,
        });
        if (!this.EditResponse)
            if (!(this.MembersAddedToList.indexOf('Father') < 0 &&
                this.MembersAddedToList.indexOf('Mother') < 0 && this.MembersAddedToList.indexOf('Spouse') < 0)) {
                this.GetGoingFormGroup.patchValue({
                    day: '',
                    month: '',
                    year: '',
                });
            }

        console.log(this.MembersAddedToList);
        this.insurerCountCheck();
    }

    triggerInsuringFor(indexValue: number, input2) {

        this.createInsuringForList(indexValue, input2);
    }
    triggerInsuringFor2(indexValue: number, input: string) {

        this.createInsuringForList(indexValue, input);
    }

    public insurerCountCheck() {
        if (this.MembersAddedToList.length === 0) {
            this.familyCheck = true;
            this.errorMessage = '';
        } else if (this.MembersAddedToList.length >= 7) {
            this.familyCheck = true;
            this.errorMessage = '(Maximum of 6 members can be insured, Maximum child members is 4';
        } else {
            this.familyCheck = false;
            this.errorMessage = '';
        }

    }


    public saveInsuringForData() {
        this.createInsuringForList();

        const memberList = [];
        this.MembersAddedToList.forEach(element => {
            memberList.push({
                'no': element === 'Self' || element === 'Spouse' ? 0 : 1,
                'relationship': element,
            });
        });


        if (!(this.MembersAddedToList.indexOf('Father') < 0 &&
            this.MembersAddedToList.indexOf('Mother') < 0 && this.MembersAddedToList.indexOf('Spouse') < 0)) {
            this.GetGoingFormGroup.patchValue({
                day: this.SelectInsurerFormGroup.get('day').value,
                month: this.SelectInsurerFormGroup.get('month').value,
                year: this.SelectInsurerFormGroup.get('year').value,
            });
        } else {
            this.SelectInsurerFormGroup.patchValue({
                day: this.GetGoingFormGroup.get('day').value,
                month: this.GetGoingFormGroup.get('month').value,
                year: this.GetGoingFormGroup.get('year').value,
            });
        }

        // this.bothDOBHasError();
        this.insuringMemberList = [...this.MembersAddedToList];
        this.insuringMemberLable = this.MembersAddedLable;
        this.SelectedSonCount = this.SonCount;
        this.SelectedDaughterCount = this.DaughterCount;
        this.googleAnalyticInsuringFor();

        this.hideDrawer('insuringForDrawer');


    }

    public checkDOBValid() {

        if (this.MembersAddedToList.indexOf('Father') < 0 &&
            this.MembersAddedToList.indexOf('Mother') < 0 && this.MembersAddedToList.indexOf('Spouse') < 0) {
            return true;
        }

        return (this.SelectInsurerFormGroup.controls['day'].valid && this.SelectInsurerFormGroup.controls['month'].valid
            && this.SelectInsurerFormGroup.controls['year'].valid);
    }

    public showEldestDOB() {
        return (this.MembersAddedToList.length === 1 && this.MembersAddedToList[0] === 'Self') || (this.MembersAddedToList.length < 1) ||
            (this.MembersAddedToList.indexOf('Father') < 0 &&
                this.MembersAddedToList.indexOf('Mother') < 0 && this.MembersAddedToList.indexOf('Spouse') < 0)
            ? false : true;
    }

    public getDateErrors() {
        return (
            ((!!this.SelectInsurerFormGroup.controls['day'].errors) &&
                (this.SelectInsurerFormGroup.controls['day'].errors.min || this.SelectInsurerFormGroup.controls['day'].errors.max)) ||
            ((!!this.SelectInsurerFormGroup.controls['month'].errors) &&
                (this.SelectInsurerFormGroup.controls['month'].errors.min || this.SelectInsurerFormGroup.controls['month'].errors.max)));
    }

    // Google Analytic function to push data in DataLayer
    public googleAnalyticTabOut() {
        this._googleAnalyticsService.pushToDataLayer({
            'event': 'radio_button_click',
            'pageType': 'Get Quote Page',
            'productName': 'Health Insurance',
            'productid': 'HGI',
            'customerType': '', // TODO
            'clickText': 'I hereby consent to recieve policy & marketing related communications via WhatsApp',
            'consentStatus': this.whatsAppConsent ? 'Agreed' : 'Not Agreed',
            'applicationId': this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId)
        });
    }

    public googleAnalyticGetQuote() {
        const mobileNo = this.GetGoingFormGroup
            .controls['mobileNumber'].value.toString();

        const formValue = this.GetGoingFormGroup.value;
        const d = parseInt(formValue['day'], 10);
        const m = parseInt(formValue['month'], 10);
        const day = d < 10 ? '0' + d : d;
        const month = m < 10 ? '0' + m : m;
        const dobProposer = formValue['year'] + '-' + month + '-' + day;

        this._googleAnalyticsService.pushToDataLayer({
            'event': 'button_click',
            'pageType': 'Get Quote Page',
            'productName': 'Health Insurance',
            'productId': 'HGI',
            'clickText': 'Get Quote',
            'validation': 'Successful', //E.g. Successful or Failed
            'customerType': '', //E.g. ETB, PTB, NTB
            'customerId': '', //If user is ETB
            'userId': '', //If user is PTB, NTB
            'leadId': '',
            'mobile': mobileNo,
            'dob': dobProposer, // todo
            'insuringFor': this.insuringFor,
            'pinCode': this.GetGoingFormGroup.controls['pinCode'].value,
            'city': this.cityName,
            'appQuoteCriteriaId': this.appQuoteCriteriaId ? this.appQuoteCriteriaId : '',
            'stagePercentage': '',// todo
            'applicationId': this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId)
        });
    }

    public googleAnalyticResendOtp() {
        const digit1Input = document.getElementById('digit1') as HTMLInputElement;
        digit1Input?.focus({ preventScroll: true });
        this._googleAnalyticsService.pushToDataLayer({
            'event': 'link_click',
            'pageType': 'Get Quote Page',//E.g. Get Quote Page
            'sectionHeading': 'OTP Verification',//E.g. Overview
            'productId': 'HGI',//E.g. HGI
            'productName': 'Health Insurance',//E.g. Health Insurance, Motor Insurance
            'section': 'Card',//E.g. Card, BodyText, etc.
            'clickText': 'Resend OTP ?',
            'customerType': '',//E.g. ETB, PTB, NTB
            'customerId': '',//If user is ETB
            'userId': '', //If user is PTB, NTB
            'leadId': '',
            'applicationId': this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId)
        });
    }

    public googleAnalyticSubmitOtp(isSuccess) {
        this._googleAnalyticsService.pushToDataLayer({
            'event': 'button_click',
            'pageType': 'Get Quote Page',            //E.g. Get Quote Page
            'productName': 'Health Insurance',         //E.g. Health Insurance, Motor Insurance
            'clickText': 'Submit OTP',           //E.g. Submit OTP
            'validation': isSuccess ? 'Successful' : 'Failed',          //E.g. Successful or Failed
            'customerType': '',        //E.g. ETB, PTB, NTB
            'customerId': '',          //If user is ETB
            'userId': '',          //If user is PTB, NTB
            'leadId': '',
            'applicationId': this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId)
        });
    }

    public googleAnalyticInsuringFor() {
        const eventValue = this.endFieldTimer(this.timerInsuringFor);
        this._googleAnalyticsService.pushToDataLayer({
            'event': 'fieldTiming',
            'eventCategory': '​Form Analytics Actions​',
            'eventAction': `Insuring For – ${this.MembersAddedToList.join('|')}`,
            'eventLabel': 'Success', // Success or Fail
            'eventValidation': 'Yes', // if Success – Yes or if Fail - Error message
            'section': 'Get Quote Page',    // Eg. Get Quote Page, Your details, tenure, etc.
            'eventValue': eventValue, // Duration (Time spent by user on the field),
            'applicationId': this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId)
        });
    }

    public googleAnalyticFullName() {
        const eventValue = this.endFieldTimer(this.timer);
        let error = null;
        if (this.FormValidators.HasError(this.GetGoingFormGroup, 'proposerName', 'required')) {
            error = 'Please provide Proposer name';
        }
        if (this.FormValidators.HasError(this.GetGoingFormGroup, 'proposerName', 'lastNameMandatory')) {
            error = 'Last name is mandatory.';
        }
        this._googleAnalyticsService.pushToDataLayer({
            'event': 'fieldTiming',
            'eventCategory': '​Form Analytics Actions​',
            'eventAction': `Full Name`,
            'eventLabel': error ? 'Fail' : 'Success', // Success or Fail
            'eventValidation': error ? error : 'Yes', // if Success – Yes or if Fail - Error message
            'section': 'Get Quote Page',    // Eg. Get Quote Page, Your details, tenure, etc.
            'eventValue': eventValue,// Duration (Time spent by user on the field)
            'applicationId': this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId)
        });

        if (!error) {
            this.startFieldTimer();
        }
    }

    googleAnalyticGender() {
        const eventValue = this.endFieldTimer(this.timer);
        let error = null;
        if (this.FormValidators.HasError(this.GetGoingFormGroup, 'gender', 'required')) {
            error = 'Mandatory field.';
        }
        this._googleAnalyticsService.pushToDataLayer({
            'event': 'fieldTiming',
            'eventCategory': '​Form Analytics Actions​',
            'eventAction': `Gender`,
            'eventLabel': error ? 'Fail' : 'Success', // Success or Fail
            'eventValidation': error ? error : 'Yes', // if Success – Yes or if Fail - Error message
            'section': 'Get Quote Page',    // Eg. Get Quote Page, Your details, tenure, etc.
            'eventValue': eventValue,// Duration (Time spent by user on the field)
            'applicationId': this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId)
        });

        if (!error) {
            this.startFieldTimer();
        }
    }

    public googleAnalyticMobileNumber() {
        const eventValue = this.endFieldTimer(this.timer);
        let error = null;
        if (this.FormValidators.FieldHasSpecificError(this.GetGoingFormGroup, 'mobileNumber', 'required')) {
            error = 'Please provide your mobile number.';
        }
        if (this.FormValidators.FieldHasSpecificError(this.GetGoingFormGroup, 'mobileNumber', 'minlength')) {
            error = 'Mobile number should be 10 digit long.';
        }
        if (!this.FormValidators.FieldHasSpecificError(this.GetGoingFormGroup, 'mobileNumber', 'minlength') &&
            this.FormValidators.FieldHasSpecificError(this.GetGoingFormGroup, 'mobileNumber', 'pattern')) {
            error = 'Please provide valid mobile number.';
        }
        this._googleAnalyticsService.pushToDataLayer({
            'event': 'fieldTiming',
            'eventCategory': '​Form Analytics Actions​',
            'eventAction': `Mobile Number`,
            'eventLabel': error ? 'Fail' : 'Success', // Success or Fail
            'eventValidation': error ? error : 'Yes', // if Success – Yes or if Fail - Error message
            'section': 'Get Quote Page',    // Eg. Get Quote Page, Your details, tenure, etc.
            'eventValue': eventValue,// Duration (Time spent by user on the field)
            'applicationId': this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId)
        });

        if (!error) {
            this.startFieldTimer();
        }
    }

    public googleAnalyticPinCode() {
        const eventValue = this.endFieldTimer(this.timer);
        let error = null;
        if (this.FormValidators.HasError(this.GetGoingFormGroup, 'pinCode', 'required')) {
            error = 'Please provide your PIN code';
        }
        if (this.FormValidators.HasError(this.GetGoingFormGroup, 'pinCode', 'pattern')) {
            error = 'Please provide your correct PIN code';
        }
        this._googleAnalyticsService.pushToDataLayer({
            'event': 'fieldTiming',
            'eventCategory': '​Form Analytics Actions​',
            'eventAction': `Pincode`,
            'eventLabel': error ? 'Fail' : 'Success', // Success or Fail
            'eventValidation': error ? error : 'Yes', // if Success – Yes or if Fail - Error message
            'section': 'Get Quote Page',    // Eg. Get Quote Page, Your details, tenure, etc.
            'eventValue': eventValue,// Duration (Time spent by user on the field)
            'applicationId': this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId)
        });

        if (!error) {
            this.startFieldTimer();
        }
    }

    public googleAnalyticOtpTime(digit) {
        //   setTimeout(() => {
        const eventValue = this.endFieldTimer(this.otpFieldtimer);
        let error = null;
        if (this.ServiceOTPError && this.resendOTPCount < 5) {
            error = this.ServiceOTPError;
        }
        if (this.wrongOtpMsg && this.resendOTPCount < 5) {
            error = this.wrongOtpMsg;
        }
        if (this.resendOTPCount >= 5) {
            error = `You've exhausted all 5 attempts to enter the correct OTP.
            Please resume your application after 10 minutes.`;
        }
        this._googleAnalyticsService.pushToDataLayer({
            'event': 'fieldTiming',
            'eventCategory': '​Form Analytics Actions​',
            'eventAction': `OTP digit ${digit}`,
            'eventLabel': error ? 'Fail' : 'Success', // Success or Fail
            'eventValidation': error ? error : 'Yes', // if Success – Yes or if Fail - Error message
            'section': 'Get Quote Page',    // Eg. Get Quote Page, Your details, tenure, etc.
            'eventValue': eventValue, // Duration (Time spent by user on the field)
            'applicationId': this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId)
        });

        if (!error) {
            this.startOtpFieldTimer();
        }
        //   });
    }

    public googleAnalyticDOB(field, type?) {
        const eventValue = this.endFieldTimer(this.timer);
        const formGroup = type === 'eldest' ? this.SelectInsurerFormGroup : this.GetGoingFormGroup;
        let error = null;
        let value;
        switch (field) {
            case 'DD':
                value = formGroup.controls['day'].value ? formGroup.controls['day'].value : '';
                break;
            case 'MM':
                value = formGroup.controls['month'].value ? formGroup.controls['month'].value : '';
                break;
            case 'YY':
                value = formGroup.controls['year'].value ? formGroup.controls['year'].value : '';
                break;
            default:
            // code block
        }

        let DOB = '';

        if (type === 'eldest') {
            DOB = `eldest DOB - ${value} (${field})`;

            if (this.getDateErrors()) {
                error = 'please provide a valid date';
            }
        } else {
            DOB = `DOB - ${value} (${field})`;
        }

        if (this.FormValidators.HasError(formGroup, 'year', 'rangeError')) {
            error = formGroup.controls['year'].errors.rangeError;
        }
        if ((this.FormValidators.HasError(formGroup, 'day', 'required') ||
            this.FormValidators.HasError(formGroup, 'month', 'required') ||
            this.FormValidators.HasError(formGroup, 'year', 'required'))) {
            error = 'This is a mandatory field.';
        }

        this._googleAnalyticsService.pushToDataLayer({
            'event': 'fieldTiming',
            'eventCategory': '​Form Analytics Actions​',
            'eventAction': DOB,  // Eg. DOB – DD, MM, YY
            'eventLabel': error ? 'Fail' : 'Success',  // Success or Fail
            'eventValidation': error ? error : 'Yes',  // if Success – Yes or if Fail - Error message
            'section': 'Get Quote Page',     // Eg. Get Quote Page, Your details, tenure, etc.
            'eventValue': eventValue,// Duration (Time spent by user on the field)
            'applicationId': this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId)
        });

        if (!error) {
            this.startFieldTimer();
        }
    }

    startInsuringForTimer() {
        this.timerInsuringFor = new Date().getTime();
    }

    startFieldTimer() {
        this.timer = new Date().getTime();
    }

    startOtpFieldTimer() {
        this.otpFieldtimer = new Date().getTime();
    }

    endFieldTimer(timer) {
        const diff = (new Date().getTime() - timer) / 1000;

        const seconds = Math.abs(Math.round(diff));
        return seconds;
    }

    public backFromOTP() {
        this.showOtpDrawer = false;
        document.getElementById('custom-header').style.display = 'block';
    }
    public otpCountDown(seconds) {
        let min: any = Math.floor(seconds / 60);
        let sec: any = seconds % 60;
        min = min < 10 ? '0' + min : min;
        sec = sec < 10 ? '0' + sec : sec;
        document.getElementById('timer') ? document.getElementById('timer').innerHTML = min + ':' + sec : '';
        seconds -= 1;
        clearTimeout(this.timer);
        if (seconds >= 0 && this.timerOn) {
            this.timer = setTimeout(() => {
                this.otpCountDown(seconds);
            }, 1000);
            return;
        }
        if (!this.timerOn) {
            return;
        }
    }

    scrollToSeo() {
        document.getElementById('seohidden').scrollIntoView(true);
    }
    private disableMobileControl() {
        this.isMobileFieldDisable = true;
        if (this._sessionHandlerService.GetSession("mobile_number")) {
            this.GetGoingFormGroup.controls['mobileNumber'].setValue(this._sessionHandlerService.GetSession("mobile_number"));
        }
        this.GetGoingFormGroup.controls['mobileNumber'].updateValueAndValidity();
    }
    private getTaskDetails() {
        const refineIncomingDate = eldestMemberDob => {
            const eldestMemberDobArr = eldestMemberDob.split('-');
            return eldestMemberDobArr[2] + '/' + eldestMemberDobArr[1] + '/' + eldestMemberDobArr[0];
        };
        this._GetGoingCall.GetCallService().subscribe((resp: ActivitiModel.MTResponse<any>) => {
            if (!resp.error) {
                if (resp) {
                    this.EditResponse = resp;
                    this.InsurerdResponse = this.EditResponse.hGIQuoteCriteria.insuredDetails;
                    this.InsuranceDetails = this.EditResponse.hGIQuoteCriteria.insuranceDetails;
                    this.insuredCount = this.InsurerdResponse.length;
                    this.PhoneNumber = this.EditResponse.mobile;
                    this.showOnlyGroupPlan = this.EditResponse.hGIQuoteCriteria.showOnlyGroupPlan ? this.EditResponse.hGIQuoteCriteria.showOnlyGroupPlan : false;
                    this.proposerDobResponse = this.EditResponse.hGIQuoteCriteria.insuranceDetails.dobProposal ? refineIncomingDate(this.EditResponse.hGIQuoteCriteria.insuranceDetails.dobProposal) : this.EditResponse.hGIQuoteCriteria.insuranceDetails.dobEldestMember ? this.EditResponse.hGIQuoteCriteria.insuranceDetails.dobEldestMember : null;
                    this.dobEldest = this.EditResponse.hGIQuoteCriteria.insuranceDetails.dobEldestMember;
                    this.PincodeResponse = this.EditResponse.hGIQuoteCriteria.insuranceDetails.pinCode;
                    this.selectedGender = this.EditResponse.hGIQuoteCriteria.insuranceDetails.gender;
                    if (this.insuredCount > 0) {
                        this.IsEdit = false;
                        this.isEditForgetGoingEdit = false;
                    }
                    this.proposerName = this.EditResponse.hGIQuoteCriteria.insuranceDetails.firstName + ' ' +
                            (this.EditResponse.hGIQuoteCriteria.insuranceDetails.middleName ? this.EditResponse.hGIQuoteCriteria.insuranceDetails.middleName + ' ' : '') +
                            this.EditResponse.hGIQuoteCriteria.insuranceDetails.lastName
                    // const namePattern = /^[a-zA-Z ]*$/;
                    // if (this.proposerName !== 'null null' && namePattern.test(this.proposerName)) {
                    //   this.GetGoingFormGroup.controls['proposerName'].setValue(this.proposerName);
                    // }
                    // console.log("set name",  this.GetGoingFormGroup.controls['proposerName'].setValue(this.proposerName));
                            
                    this.setUserInput();
                    this.patchInsuringFor();
                    this.ValidateMobile();
                    this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.JourneyType, '');
                    this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.selectedPlanType, '');
                    console.log(resp);
                }
            } else {
                this._sessionHandlerService.DeleteSession([CommonConstants.CookieKeys.processId]);
            }
        });
    }
    public setUserInput(ssoUserDedupeData?) {
        console.log("setUserInput - ssoUserDedupeData", ssoUserDedupeData)
        let proposerName: string = '';
        let day: string;
        let month: string;
        let year: string;
        if (!this.isLandingPage) {
            if (this.InsuranceDetails && this.InsuranceDetails.firstName) {
                proposerName = this.InsuranceDetails.firstName + ' ' +
                    (this.InsuranceDetails.middleName ? this.InsuranceDetails.middleName + ' ' : '') +
                    this.InsuranceDetails.lastName;
            }
            if (this.proposerDobResponse) {
                if (this.proposerDobResponse.includes('-')) {
                    this.proposerDobResponse = this.proposerDobResponse.split('-').reverse().join('/');
                }
                const dobSplit = this.proposerDobResponse.split('/');
                day = dobSplit[0];
                month = dobSplit[1];
                year = dobSplit[2];
            }
        }
        /**Below code is commented as we have to prefill get quote details for app in case of SSO BFSDINSTSK-23906 */
        // if (this.isMobileFlag && this.isLandingPage) {
        //     proposerName = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.full_name) || '';
        //     const gender = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.gender) || '';
        //     this.selectedGender = gender && gender[0].toUpperCase() + gender.slice(1).toLowerCase();
        //     const pincode = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.pin_code) || '';
        //     this.PincodeResponse = pincode;
        //     let dateOfBirth = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.dob) || '';
        //     const dobPattern = /^\d{4}\-\d{2}\-\d{2}$/;
        //     // following condition handled if we get masked date then it will not get pre-filled
        //     if (dobPattern.test(dateOfBirth)) {
        //         if (dateOfBirth.includes('-')) {
        //             dateOfBirth = dateOfBirth.split('-').reverse().join('/');
        //         }
        //         const dobSplit = dateOfBirth.split('/');
        //         day = dobSplit[0];
        //         month = dobSplit[1];
        //         year = dobSplit[2];
        //     }
        //     const mobile_number = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.mobile_number) || '';
        //     if (mobile_number) {
        //         this.PhoneNumber = mobile_number;
        //         this.disableMobileControl();
        //     }
        // }

        //If we get SSO response details from CUSTOMER_DEDUPE_API call then will set those in get quote page
        if (ssoUserDedupeData) {
            this.demogApiResponse = ssoUserDedupeData;
            if (ssoUserDedupeData.firstName) {
                this.proposerName = ssoUserDedupeData.firstName + ' ' +
                    (ssoUserDedupeData.middleName ? ssoUserDedupeData.middleName + ' ' : '') +
                    ssoUserDedupeData.lastName
            }
            this.PhoneNumber = ssoUserDedupeData.mobileNo;
            this.isMobileFieldDisable = true;
            this.PincodeResponse = ssoUserDedupeData.pinCode;
            const pincodePattern = /^[0-9]*$/;
            if(pincodePattern.test(this.PincodeResponse)){
                this.PincodeResponse = this.PincodeResponse;
            }
            const gender = ssoUserDedupeData.gender || '';
            this.selectedGender = gender && gender[0].toUpperCase() + gender.slice(1).toLowerCase();
            let dateOfBirth = ssoUserDedupeData.dob || '';
            const dobPattern = /^[0-9]{4}\-[0-9]{2}\-[0-9]{2}$/;
            // following condition handled if we get masked date then it will not get pre-filled
            if (dobPattern.test(dateOfBirth)) {
                if (dateOfBirth.includes('-')) {
                    dateOfBirth = dateOfBirth.split('-').reverse().join('/');
                }
                const dobSplit = dateOfBirth.split('/');
                day = dobSplit[0];
                month = dobSplit[1];
                year = dobSplit[2];
            }
        }

        const namePattern = /^[a-zA-Z ]*$/;
        if (this.proposerName !== 'null null' && namePattern.test(this.proposerName)) {
            this.GetGoingFormGroup.controls['proposerName'].setValue(this.proposerName);
        }

        // this.GetGoingFormGroup.controls['gender'].setValue(this.selectedGender);
        if (this.PhoneNumber) {
            this.GetGoingFormGroup.controls['mobileNumber'].setValue(this.PhoneNumber);
        }
        if (ssoUserDedupeData || (this.ssoEnabled === true)) {
            this.disableMobileControl();
        }
        if (this.GetGoingFormGroup.controls['mobileNumber'].value) {
            this.ValidateMobile();
        }
        if (this.PincodeResponse) {
            let event = {
                target: {
                    value: this.PincodeResponse
                }
            }
            this.OnPincodeChange(event);
        }
        // this.GetGoingFormGroup.controls['day'].setValue(day);
        // this.GetGoingFormGroup.controls['month'].setValue(month);
        // this.GetGoingFormGroup.controls['year'].setValue(year);
    }

    public cleverTapPayload() {
        const formDataProposer = { ...this.GetGoingFormGroup.value };
        const proposalDOBObj = {
            Day: formDataProposer.day,
            Month: formDataProposer.month,
            Year: formDataProposer.year
        };

        const proposerDob = new Date(proposalDOBObj.Year, proposalDOBObj.Month, proposalDOBObj.Day);
        this._cleverTapService.cleverTapUserCreation({
            "Name": this.GetGoingFormGroup.controls['proposerName'].value,
            "Identity": "+91" + this.GetGoingFormGroup.controls['mobileNumber'].value,
            // "Gender": this.GetGoingFormGroup.controls['gender'].setValue(this.selectedGender),
            "Phone": "+91" + this.GetGoingFormGroup.controls['mobileNumber'].value,
            "pincode": this.GetGoingFormGroup.controls['pinCode'].value,
            "EP_DOB": proposerDob,
            "creation_time": new Date()
        });
        this._cleverTapService.clevertapPwaEvents("INSURANCE_PWA_VIEWED",
            {
                "EP_INSURANCE_PAGE": "HEALTHHOME",
                // "EP_SOURCE": "NOTIFICATION/WIDGET/BANNER", (EP_SOURCE has been removed as per the requirement)
                "EP_INSURING_FOR": this.insuringFor ? this.insuringFor : 'Individual',
                "EP_NAME": this.GetGoingFormGroup.controls['proposerName'].value,
                // "EP_GENDER": this.GetGoingFormGroup.controls['gender'].value,
                "EP_DOB": proposerDob,
                "EP_MOBILE_NO": this.GetGoingFormGroup.controls['mobileNumber'].value,
                "EP_PINCODE": this.GetGoingFormGroup.controls['pinCode'].value,
                "EP_CTA": "GET QUOTE"
            })
    }


    private decodeEPObject(epCookieString: string) {
        let decodedEPObject;
        if (this._cookieHandler.GetCookie(epCookieString)) {
            const decodedString = decodeURIComponent(this._cookieHandler.GetCookie(epCookieString));
            decodedEPObject = JSON.parse(decodedString);
        }
        return decodedEPObject;
    }

    public getSystemToken() {
        this._currentRoute.url.forEach(url => {
            if (url.toString() == CommonConstants.Routes.Application.GetGoingNowEdit) {
                const productCode = CommonConstants.LOAN_PRODUCT_CODES.Health_Insurance;
                this._homeService.GetSystemAuthToken({
                    productCode
                }).subscribe((responseData: ActivitiModel.MTResponse<any>) => {
                    if (!responseData.errorBean) {
                        const tokenObj = responseData.payload.tokens[0];
                        console.log('tokens::', tokenObj);
                        this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.JWToken, tokenObj.token);
                        if (this._routeContextProvider.GetQueryParams
                            (CommonConstants.QueryParamsKeys.IsMobile) === '1') {
                            const psuedoVerifiedToken = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.PSVToken);
                            this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.JWToken, psuedoVerifiedToken);
                        } else {
                            const psuedoVerifiedToken = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.JWToken);
                            this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.JWToken, psuedoVerifiedToken);
                        }
                        this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.GuardKey, tokenObj.guardKey);
                        this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.GuardToken, this.formatter
                            .ConvertGuradKeyToGuardToken(tokenObj.guardKey));
                    } else {
                    }
                });
            }
        });
    }

    prefillSSOUserData() {
        const payload = {
            "mobileNumber": this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.mobile_number)
        };
        this.ssoService.getPrefilledUserData(payload).subscribe((response: any) => {
            if (response) {
                // update response for development
                // response['firstName'] = 'Atul';
                // response['middleName'] = 'S';
                // response['lastName'] = 'Kulkarni';
                // response['gender'] = 'male';
                // response['dob'] = '17/03/1976';
                // response['mobileNo'] = '9594225689';
                console.log("getPrefilledUserData-", response);
                this.setUserInput(response);
            }
        }, (error: any) => {
            console.log('error', error)
        });
    }


    private getDefaultInsuringForList() {
        this.MembersAddedToList = ['Self'];
        this.MembersAddedLable = 'Self';
        const formControls = this.InsuredMemberList.map(control => {
            if (control.title === 'Self') {
                return new FormControl(true);
            } else {
                return new FormControl(false);
            }
        });
        return formControls;
    }
    public showDrawer(drawerName, errorMessage) {
        this._dialogRef = this._dialogService.open(CommonErrorMessageDrawerComponent, {
            data: {
                title: 'Oops',
                desc: errorMessage
            },
            panelClass: drawerName,
            hasBackdrop: true,
            disableClose: true,
            showMinimizedButton: true,
            closeOnOutsideClick: false
        });
        this._dialogRef.afterClosed.subscribe(result => {
            this.closeDrawer();
        });
    }

    public closeDrawer() {
        this.GetGoingFormGroup.reset();
    }

}
